
export enum ValidationRuleTriggerRequirement {

    None = 0,
     // eslint-disable-next-line no-bitwise
    Dirty = 1 << 0,
     // eslint-disable-next-line no-bitwise
    Touched = 1 << 1,
     // eslint-disable-next-line no-bitwise
    All = ~(~0 << 2)
}
